import React from 'react';
import { compose, withApollo } from 'react-apollo';
import { Button, Dimmer, Grid, Loader, Message } from 'semantic-ui-react';
import { UpdateDocument } from "../mutations/UpdateDocument";
import { findDocumentType } from '../utils/documentTypes';
import DocumentPreview from './DocumentPreview';

class DocumentForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      form: this.initialFormValues(this.props)
    };
    this.handleRef = this.handleRef.bind(this)
  }


  componentWillReceiveProps(nextProps) {
    if (!this.props.document) {
      this.setState({ form: this.initialFormValues(nextProps) })
    }
  }

  initialFormValues(props) {
    const document = this.props.document || {}
    const formAttributes = JSON.parse(document.formAttributes);
    return Object.keys(formAttributes).reduce((prevKey, currKey)=> ({
        ...prevKey,
        [currKey]:formAttributes[currKey] !== null ? formAttributes[currKey] : ''
      }), {});
  }

  handleSave = (isFormValid) => {
    this.setState({ loading: true })

    const document = this.props.document || {}
    this.props.client.mutate({
      mutation: UpdateDocument,
      variables: {
        input: {
          document: {
            id: document.id,
            formAttributes: JSON.stringify(this.state.form)
          }
        }
      }
    }).then(({ data }) => {
      this.props.handleClose()
      this.props.onUpdateDocumentSuccess(data)
    }).catch((error) => {
      console.error(error)
      this.setState({ loading: false })
    })
  }

  handleSaveClick = () => {
    const documentFormRef = this.documentFormRef
    const form = documentFormRef
    form.validateForm()


    setTimeout(() => {
      const form = documentFormRef
      if (form.props.isValid) {
        this.handleSave()
      }
    }, 0)
  }

  handleDataChange = (documentId, name, value) => {
    const { form } = this.state
    form[name] = value;
    this.setState({ form })
  }

  render = () => {
    const { document } = this.props
    const flight = this.props.claim ? this.props.claim.flight : {}
    const passengerTicket = document.claimsPassengerTicket.passengerTicket
    const FormComponent = this.formComponentForDocument(document)
    const form = FormComponent !== undefined ? (
      <FormComponent
        formValues={this.state.form}
        onDataChange={this.handleDataChange}
        documentId={document.id}
        onRef={this.handleRef}
        passengerTicket={passengerTicket}
        flight={flight}
      />
    ) : (<Message> Missing document type </Message>)
    return (
      <Grid style={{height: '90vh'}}>
        {this.state.loading && <Dimmer active inverted> <Loader size='large' /> </Dimmer>}
          <Grid.Row key={document.id} columns={2}>
            <Grid.Column textAlign="right" style={{height: '80vh'}}>
              <DocumentPreview document={document} zoomablePDF />
            </Grid.Column>
            <Grid.Column>
              {form}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={1}>
            <Grid.Column verticalAlign='bottom'>
              <Button positive floated="right" onClick={this.handleSaveClick.bind(this)}>Save</Button>
              <Button floated="right" onClick={this.props.handleClose}>Close</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
    )
  }

  handleRef(documentId, ref) {
    this.documentFormRef= ref
  }

  formComponentForDocument(document) {
    return findDocumentType(document.type).formComponent
  }
}

const DocumentFormWithData = compose(
  withApollo
)(DocumentForm)

export default DocumentFormWithData;



// WEBPACK FOOTER //
// ./src/component/DocumentForm.js